<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Menu -->
        <menu-album
            :profil="profil"
        />

        <!-- Main -->
        <main>
            <div class="albumMainBody">

                <div class="albumPages">
                    <div class="albumPage --first"></div>
                    <div class="albumPage --second"></div>
                    <div class="albumPage --third"></div>
                    <div class="albumPage --fourth"></div>
                </div>    

                <button @click="$router.push({ name: 'profil' })" class="sideMenu__close"><span class="icon"></span></button>
                <div class="albumList__separator"></div>

                <!-- Recepty -->
                <div class="albumListing__wrap">

                    <!-- 1. strana -->
                    <div class="albumList__half --first">
                        <!-- Header -->
                        <div class="albumList__heading mb-3 d-flex align-items-center justify-content-between">
                            <h2 class="mb-0">Mliečne recepty <span class="icon --questionMark" @click="$bvModal.show('modalAlbumAnatomia')"></span></h2>
                            <p class="mb-0">Máš <span class="--bold">{{ countOwned }}</span> z celkových <span class="--bold">{{ countTotal }} receptov</span></p>
                            <!--<p class="mb-0">Odomkol si <span class="--bold">{{ percOwned }}%</span> receptov</p>-->
                        </div>

                        <!-- Recept box -->
                        <div v-if="album.recepty" class="albumListing__list --recepty">
                            <div v-if="index >= startIndex && index <= (endIndex - 9)" 
                                 v-for="(recept, index) in album.recepty" 
                                 @click="checkItem(recept, index)" 
                                 :class="'albumListing__item' + [recept.current == recept.album_recepty_max ? ' --done' : '']">

                                <!-- Image -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'assets/img/album/recepty/' + recept.album_recepty_img_a" alt="" class="img-fluid" >
                                </div>

                                <!-- Názov -->
                                <div class="albumListing__descriptionWrap">
                                    <p class="albumListing__name mb-0">{{ recept.album_recepty_nadpis }}</p>
                                    <!-- Progres -->
                                    <div class="albumListing__progress">
                                        <span v-for="(bar, rindex) in recept.album_recepty_max">
                                            <span v-if="recept.current >= (rindex + 1)" class="albumListing__bar --full"></span>
                                            <span v-else class="albumListing__bar"></span>
                                        </span>
                                    </div>
                                </div>

                                <span v-if="recept.current == recept.album_recepty_max" class="albumListing__checkmark"></span>

                            </div>
                        </div>
                    </div>

                    <!-- 2. strana -->
                    <div v-if="album.recepty" class="albumList__half --second">
                        <!-- Recept box -->
                        <div class="albumListing__list --recepty">
                            <div v-if="index >= (startIndex + 9) && index <= endIndex" 
                                 v-for="(recept, index) in album.recepty" 
                                 @click="checkItem(recept, index)" 
                                 :class="'albumListing__item' + [recept.current == recept.album_recepty_max ? ' --done' : '']">

                                <!-- Image -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'assets/img/album/recepty/' + recept.album_recepty_img_a" alt="" class="img-fluid" >
                                </div>

                                <!-- Názov -->
                                <div class="albumListing__descriptionWrap">
                                    <p class="albumListing__name mb-0">{{ recept.album_recepty_nadpis }}</p>
                                    <!-- Progres -->
                                    <div class="albumListing__progress">
                                        <span v-for="(bar, rindex) in recept.album_recepty_max">
                                            <span v-if="recept.current >= (rindex + 1)" class="albumListing__bar --full"></span>
                                            <span v-else class="albumListing__bar"></span>
                                        </span>
                                    </div>
                                </div>

                                <span v-if="recept.current == recept.album_recepty_max" class="albumListing__checkmark"></span>

                            </div>
                        </div>
                    </div>

                </div>

                <!-- Paginácia -->
                <div v-if="prevPage != 0" @click="changePage(currentPage - 1)" class="albumListing__nav --prev">
                    <span class="icon --prev"></span>Predchádzajúca strana
                </div>
                <div v-if="nextPage != 0" @click="changePage(currentPage + 1)" class="albumListing__nav --next">
                    Ďalšia strana<span class="icon --next"></span>
                </div>

            </div>
        </main>

        <!-- Modal -->
        <b-modal id="modalAlbumAnatomia" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalAlbumAnatomiaTitle" aria-hidden="true" ref="modalAlbumAnatomia">
            <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalAlbumAnatomia')"><span class="icon"></span></b-button>

            <!-- Content -->
            <div class="modal-body" style="padding:0">
                <div class="text-center">

                    <h2 class="text-center">Nápoveda</h2>
                    <p class="text-18">Fajnoty s použitím mliečnch výrobkov si môžeš pripraviť rýchlo a ľahko. Inšpiruj sa napríklad aj týmito receptami. Do tejto kuchárskej knihy ich dostaneš za točenie kolesom šťastia, alebo za dosiahnuté úspechy v tvojej hre.</p>
                    
                </div>
            </div>
            <!-- .Content -->
        </b-modal>
        <!-- .Modal -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderObchod from '../partials/HeaderObchod.vue'
    import MenuAlbum    from '../partials/MenuAlbum.vue'
    export default {
        components: {
            HeaderObchod,
            MenuAlbum
        },
        props: [
            'profil',
            'album',
            'error'
        ],
        mounted() {
            this.toggleBodyClass('addClass', 'album')
            this.toggleBodyClass('addClass', '--recepty')
            if (typeof(this.profil.id) == "undefined" || this.profil.id == 0) {
                this.$emit('updateProfil')
            }

            //sessionStorage.setItem("album-recepty", "refresh")
            this.getAlbumData('recepty')
            this.checkPagination()
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'album')
            this.toggleBodyClass('removeClass', '--recepty')
        },
        updated() {
            if (this.updated == 0) {
                this.getAlbumData('recepty')
            }
        },
        data() {
            return {
                countTotal: 0,
                countOwned: 0,
                percOwned: 0,

                prevPage: 0,
                currentPage: 0,
                nextPage: 0,
                startIndex: 0,
                endIndex: 17,

                updated: 0,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },


            // mounted
            getAlbumData(typ) {
                if (typeof(this.profil.pouzivatel_id) != 'undefined' && this.profil.id != 0) {
                    this.updated = 1

                    if ( typeof(this.album.recepty) == 'undefined' || sessionStorage.getItem("album-recepty") ) {
                        EventService.getAlbumData(typ)
                            .then(response => {
                                //console.log(response.data.data)
                                sessionStorage.removeItem("album-recepty")

                                // progres pre získané recepty
                                var items = response.data.data
                                this.countOwned = 0
                                this.countTotal = items.length

                                for (var i = 0; i < items.length; i++) {
                                    // album progres
                                    items[i].current = 0
                                    var key = this.profil.pouzivatel_id.album_pouzivatela.findIndex(repo => 
                                        repo.album_item_id == items[i].id &&  repo.repozitar_albumu_category == "recepty"
                                    )

                                    if (key >= 0) {
                                        items[i].current = parseInt(this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current)
                                        if (parseInt(this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current) == parseInt(items[i].album_recepty_max)) {
                                            this.countOwned += 1
                                        }
                                    }
                                }
                                this.percOwned = ((this.countOwned / this.countTotal) * 100).toString().substring(0, 5)
                                this.checkPagination()

                                // emit alternative
                                this.$set(this.album, 'recepty', items)
                            })
                            .catch(error => {
                                this.responseType = 'warning'
                                this.responseText = error
                            })

                    } else {
                        for (var i = 0; i < this.album.recepty.length; i++) {
                            if (parseInt(this.album.recepty[i].current) == parseInt(this.album.recepty[i].album_recepty_max)) {
                                this.countOwned += 1
                            }
                        }
                        this.countTotal = this.album.recepty.length
                        this.percOwned  = ((this.countOwned / this.countTotal) * 100).toString().substring(0, 5)
                    }
                }
            },

            checkPagination() {
                if (this.countTotal > 18 || (typeof(this.album.recepty) != 'undefined' && this.album.recepty.length > 18)) {
                    this.nextPage = 1
                }
            },


            // click
            checkItem(recept, index) {
                if (recept.current == recept.album_recepty_max) {
                    this.$router.push({ name: 'album-recepty-detail', params: { recept_id: recept.id } })
                }
            },

            changePage(x) {
                // draw current page
                this.startIndex = 0 + (18 * x)
                this.endIndex   = this.startIndex + 17

                // set pages
                this.nextPage    = 0
                this.prevPage    = x
                this.currentPage = x
                if ( this.endIndex < (this.countTotal - 1) || (typeof(this.album.recepty) != 'undefined' && this.endIndex < (this.album.recepty.length - 1)) ) {
                    this.nextPage = 1
                }

                //console.log(x + ': ' + this.startIndex + '-' + this.endIndex)
                //console.log(this.nextPage + ': ' + this.endIndex + '>' +this.countTotal)
            },
        }
    }
</script>